<div class="ai-summary-content" *ngIf="summaryState$ | async as summaryState">
  <ng-container [ngSwitch]="summaryState.status">
    <div class="ai-summary-success" *ngSwitchCase="'success'">
      <div class="ai-summary-header">
        <h2>{{ summaryTitle }}</h2>
        <div class="ai-summary-badge">
          <mat-icon svgIcon="sparkles"></mat-icon>
          <span>AI generated</span>
        </div>
      </div>
      <div
        class="ai-summary-body"
        [ngClass]="{ 'is-collapsed': isCollapsed, 'is-expanded': !isCollapsed }"
      >
        <ng-container *ngIf="getStateData(summaryState) as summaryData">
          <!--Render as segments-->
          <p *ngIf="getSegments(summaryData) as segments">
            <ng-container *ngFor="let segment of segments">
              <span
                class="link-style"
                *ngIf="$any(segment).type === 'term'"
                (click)="onSegmentClicked(segment)"
                >{{ $any(segment).text }}</span
              >
              <span *ngIf="$any(segment).type !== 'term'">{{ $any(segment).text }}</span>
            </ng-container>
          </p>
          <!--Render as regular text-->
          <p *ngIf="getSummaryText(summaryData) as summaryText">{{ summaryText }}</p>
        </ng-container>
      </div>
      <div class="ai-summary-actions" *ngIf="expandable">
        <div class="ai-summary-action" (click)="toggleExpanded()">
          <mat-icon svgIcon="{{ isExpanded ? 'minus' : 'plus' }}"></mat-icon>
          <span> {{ isExpanded ? 'Read less' : 'Read more' }} </span>
        </div>
      </div>
    </div>

    <ai-summary-loading *ngSwitchCase="'loading'"></ai-summary-loading>

    <div class="ai-summary-error" *ngSwitchCase="'error'">
      <mat-icon svgIcon="robot-fail"></mat-icon>
      <p>Summary generation timeout. <a (click)="onTryAgain()">Try again</a></p>
    </div>
  </ng-container>
</div>
